var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-5 mt-5 text-center",attrs:{"color":"secondary"}},[_c('v-card-title',{staticClass:"mb-5 d-block text-h4"},[_vm._v("storage")]),_c('v-card-subtitle',{staticClass:"text-center"},[_vm._v("your account has currently used: "),_c('br'),_vm._v(" "+_vm._s(_vm.user.storage_used))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }